import script from "./SummaryView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SummaryView.vue?vue&type=script&lang=ts&setup=true"

import "./SummaryView.vue?vue&type=style&index=0&id=b97b369a&scoped=true&lang=css"

import exportComponent from "/Users/jnshul/Documents/tagluffa_i_vue3/main_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b97b369a"]])

export default __exports__